import { QuoteListItem } from '../../components/QuoteListItem'

export const QuotePdfGenerationTimeoutListItem = (props: {
  taskId: string
  isSelected: boolean
  hideUnreadIndicator?: boolean
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}) => <QuoteListItem {...props} description="PDF generation timed out" />
